import { useMemo, useState } from 'react'
import * as ClientHttp from '../../../../../services/api/https/registration/client.http'
import { errorHandler } from '../../../../../services/util/error.service'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  SAVE_STRETCH: 'Salvando trechos',
  GET_STRETCH: 'Adquirindo trechos',
  DELETE_STRETCH: 'Deletando trecho',
}

const INITIAL_STATE = {
  associations: [],
  tp_id: 0,
  centraloperacoes_id: 0,
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
  selectedStrechToDelete: null,
  client_id: 0,
}

export default function useModalAssocStretch() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    return {
      // Actions
      saveTrechos(client_id, tp_id, centraloperacoes_id) {
        ClientHttp.saveTrechos({ client_id, tp_id, centraloperacoes_id })
          .then(associationsRes =>
            setState(prevState => ({
              ...prevState,
              associations: associationsRes,
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      getTrechos(client_id, centraloperacoes_id) {
        ClientHttp.getTrechos(client_id, centraloperacoes_id)
          .then(associationsRes =>
            setState(prevState => ({
              ...prevState,
              associations: associationsRes,
              centraloperacoes_id: centraloperacoes_id,
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      deleteTrechos(trecho_id, centraloperacoes_id) {
        ClientHttp.deleteTrechos(trecho_id, centraloperacoes_id)
          .then(associationsRes =>
            setState(prevState => ({
              ...prevState,
              associations: associationsRes,
              centraloperacoes_id: centraloperacoes_id,
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      resetState() {
        setState(INITIAL_STATE)
      },

      // Events
      onBtnSalvarClicked(tp_id, centraloperacoes_id) {
        if (!tp_id || !centraloperacoes_id)
          setState(prevState => ({
            ...prevState,
            errorMessage: 'Operador logístico, ou central de operações não selecionado.',
            loadingMessage: LOAD_MESSAGE.NONE,
          }))
        else setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.SAVE_STRETCH }))
      },

      onOperadorChange(tp_id) {
        setState(prevState => ({ ...prevState, tp_id: tp_id }))
      },

      onCentralChange(centraloperacoes_id) {
        setState(prevState => ({
          ...prevState,
          centraloperacoes_id: centraloperacoes_id,
          loadingMessage: LOAD_MESSAGE.GET_STRETCH,
        }))
      },

      onBtnDeleteClicked(strechID) {
        setState(prevState => ({
          ...prevState,
          selectedStrechToDelete: strechID,
          loadingMessage: LOAD_MESSAGE.DELETE_STRETCH,
        }))
      },
    }
  }, [])

  return { state, localDispatch }
}
